/* San Rocco Italia: native cart drawer bridge for existing SRI Free Shipping v9+. */
(function () {
  'use strict';
  if (window.__sriDrawerBridgeLoaded) return;
  window.__sriDrawerBridgeLoaded = true;

  let lastPanel = null;
  let syncTimer;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function inheritShippingSettings(panel) {
    const announcement = document.querySelector('[data-sri-shipping][data-mode="announcement"]');
    if (!announcement || !announcement.dataset.rules) {
      panel.hidden = true; // Never show a promise without verified shipping rules.
      return false;
    }
    panel.dataset.rules = announcement.dataset.rules;
    panel.dataset.vendorMode = announcement.dataset.vendorMode || 'all';
    panel.dataset.eligibleVendors = announcement.dataset.eligibleVendors || '';
    // Localise the drawer to the same selected market as the announcement.
    panel.dataset.country = announcement.dataset.country || panel.dataset.country;
    panel.dataset.currency = announcement.dataset.currency || panel.dataset.currency;
    for (const key of ['vendorEmpty', 'vendorNoEligible', 'vendorRemainingMixed', 'vendorReachedMixed']) {
      if (announcement.dataset[key]) panel.dataset[key] = announcement.dataset[key];
    }
    return true;
  }

  function mountPanel() {
    const drawer = document.querySelector('cart-drawer');
    const panel = drawer && drawer.querySelector('[data-sri-drawer]');
    if (!panel || panel === lastPanel) return;
    lastPanel = panel;
    if (!inheritShippingSettings(panel)) return;
    // The existing shipping script listens for this same Shopify section event:
    // it adds the regional info icon and refreshes cart/vendor calculations.
    document.dispatchEvent(new Event('shopify:section:load'));
    document.dispatchEvent(new Event('cart:refresh'));
  }

  async function rerenderNativeDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function' || typeof drawer.renderContents !== 'function') return;
    const sections = drawer.getSectionsToRender().map(section => section.id);
    if (!sections.length) return;
    try {
      const url = root + '?sections=' + encodeURIComponent(sections.join(','));
      const resp = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
      if (!resp.ok) return;
      const html = await resp.json();
      if (!sections.every(id => typeof html[id] === 'string')) return;
      drawer.renderContents({ sections: html });
    } catch (_) { /* Never interfere with Shopify checkout on a failed refresh. */ }
  }

  function start() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    mountPanel();
    // Dawn/Studio swaps the drawer HTML after a cart update. Rebind only
    // when our panel itself changes, avoiding a MutationObserver update loop.
    const observer = new MutationObserver(function () {
      const current = drawer.querySelector('[data-sri-drawer]');
      if (current !== lastPanel) {
        if (syncTimer) clearTimeout(syncTimer);
        syncTimer = setTimeout(function () {
          lastPanel = null;
          mountPanel();
        }, 0);
      }
    });
    observer.observe(drawer, { childList: true, subtree: true });
    // Existing SRI upsell adds via Ajax. Refresh native drawer and cart icon
    // afterwards, rather than leaving the Shopify totals and items stale.
    document.addEventListener('sri:cart:updated', rerenderNativeDrawer);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
